import { useMemo, useState } from "react";
import ChecklistsTable from "./ChecklistsTable";
import { Box, Button, IconButton, InputAdornment, TextField, useMediaQuery } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Add from "@mui/icons-material/Add";
import AddChecklistDialog from "../dialogs/AddChecklistDialog";
import { useOrderContext } from "context/OrderContext";
import CancelIcon from "@mui/icons-material/Cancel";
import ChecklistsList from "./ChecklistsList";
import EmptyMessage from "components/EmptyMessage";

const ChecklistsSection: React.FC = () => {
  const order = useOrderContext();
  const { checklists } = order;
  const [searchString, setSearchString] = useState<string>("");
  const [showAddChecklistDialog, setShowAddChecklistDialog] = useState<boolean>(false);
  const isLargeScreen = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const filteredChecklists = useMemo(() => {
    if (!checklists) return [];

    return checklists.filter(
      (checklist) =>
        !searchString || checklist.roomName.toLowerCase().includes(searchString.toLowerCase())
    );
  }, [checklists, searchString]);

  return (
    <Box p={1}>
      {!!checklists.length && (
        <Box sx={{ mb: 1, display: "flex", justifyContent: "space-between" }}>
          <TextField
            label="Sök checklista"
            variant="filled"
            value={searchString}
            onChange={(e) => setSearchString(e.target.value)}
            sx={(theme) => ({ width: "100%", [theme.breakpoints.up("sm")]: { maxWidth: "30ch" } })}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end" hidden={!searchString}>
                    <IconButton onClick={(e) => setSearchString("")} edge="end">
                      <CancelIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
        </Box>
      )}

      {!!order.parentOrderNumber ? (
        <EmptyMessage m={1}>Denna order rapporteras på huvudordern</EmptyMessage>
      ) : !checklists.length ? (
        <EmptyMessage m={1}>Inga checklistor skapade</EmptyMessage>
      ) : isLargeScreen ? (
        <ChecklistsTable checklists={filteredChecklists} />
      ) : (
        <ChecklistsList checklists={filteredChecklists} />
      )}

      {!order.parentOrderNumber && (
        <Box
          sx={(theme) => ({
            display: "flex",
            mt: 1,
            justifyContent: "center",
            [theme.breakpoints.up("md")]: {
              justifyContent: "flex-end",
            },
          })}
        >
          <Button
            variant="contained"
            onClick={() => setShowAddChecklistDialog(true)}
            startIcon={<Add />}
          >
            Ny checklista
          </Button>
        </Box>
      )}

      {showAddChecklistDialog && (
        <AddChecklistDialog onClose={() => setShowAddChecklistDialog(false)} />
      )}
    </Box>
  );
};

export default ChecklistsSection;
